import { Injectable } from "@angular/core";
import { BackendService } from "../../../core/services/backend-service";
import {
  TileTypeEnum,
  TypedTile,
} from "src/app/core/interfaces/tile-interface";
import {
  CreateFavoriteFilterSearchRequestInterface,
  FavoriteFilterSearchInterface,
} from "src/app/core/interfaces/favorite-interface";
import { MobilityContactCardInterface } from "src/app/core/interfaces/mobility-contact-card-interface";

@Injectable({
  providedIn: "root",
})
export class FavoritesService extends BackendService {
  getFavoriteTiles(): Promise<TypedTile[]> {
    return this.get<TypedTile[]>("api/favorite-tiles");
  }

  addTileToFavorites(
    id: string,
    tileType: TileTypeEnum = TileTypeEnum.Other
  ): Promise<void> {
    return this.post<{ id: string; tileType: TileTypeEnum }, void>(
      "api/favorite-tiles",
      {
        id,
        tileType,
      }
    );
  }

  deleteManyTilesFromFavorites(tileIds: string[]): Promise<void> {
    return this.delete<void>("api/favorite-tiles", undefined, tileIds);
  }

  getFavoriteFilterSearch(): Promise<FavoriteFilterSearchInterface[]> {
    return this.get<FavoriteFilterSearchInterface[]>("api/favorite-searches");
  }

  deleteManyFiltersSearchesFromFavorites(searchIds: number[]): Promise<void> {
    const stringifiedIds = searchIds.map((id) => id.toString());
    return this.delete<void>("api/favorite-searches", undefined, stringifiedIds);
  }

  async saveSearch(
    createFavoriteFilterSearchRequest: CreateFavoriteFilterSearchRequestInterface
  ): Promise<void> {
    await this.post<CreateFavoriteFilterSearchRequestInterface, void>(
      "api/favorite-searches",
      {
        ...createFavoriteFilterSearchRequest,
      }
    );
  }

  getFavoriteContacts(): Promise<MobilityContactCardInterface[]> {
    return this.get<MobilityContactCardInterface[]>("api/favorite-contacts");
  }
}
